var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      ref: "thisModal",
      attrs: { "content-css": { minWidth: "96vw", minHeight: "96vh" } },
      model: {
        value: _vm.modalOpened,
        callback: function($$v) {
          _vm.modalOpened = $$v
        },
        expression: "modalOpened"
      }
    },
    [
      _c(
        "div",
        { staticStyle: { width: "100%", height: "90vh" } },
        [
          _c("tui-image-editor", {
            ref: "tuiImageEditor",
            attrs: {
              "include-ui": _vm.tuiUseDefaultUI,
              options: _vm.tuiOptions
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }